import { matchPath } from '../router/matchPath';

// 获取平台名称可以用 Platform[Platform.Desktop]
export enum Platform {
  Desktop,
  iPhone,
  iPad,
  Android,
  Mobile,
  MobileUA,
}

export function getFirstPathInUrl(): string {
  const pathname = window?.location?.pathname || '';

  if (!pathname) {
    return '';
  }
  const pathMatch = matchPath<{ firstPath: string }>(pathname, {
    path: '/:firstPath/',
  });
  return pathMatch?.params?.firstPath || '';
}

export function platformType(): Platform {
  if (/(Meego)/i.test(navigator.userAgent)) {
    return Platform.Mobile;
  } else if (/(iPad)/i.test(navigator.userAgent)) {
    return Platform.iPad;
  } else if (/(iPhone|iPod)/i.test(navigator.userAgent)) {
    return Platform.iPhone;
  } else if (/(Android)/i.test(navigator.userAgent)) {
    return Platform.Android;
  } else if (/(Mobile)/i.test(navigator.userAgent)) {
    return Platform.MobileUA;
  } else {
    return Platform.Desktop;
  }
}

export function whichOsName() {
  const ua = window.navigator.userAgent;
  let osName = 'unknown';
  if (/android/i.test(ua)) {
    osName = 'android';
  }
  if (/iPhone|iPad|iPod|iOS/i.test(ua)) {
    osName = 'ios';
  }
  if (ua.includes('(Macintosh; Intel ')) {
    osName = 'mac';
  }
  if (/Win\d{2}|Windows/.test(ua)) {
    osName = 'windows';
  }
  return osName;
}

export function getBrowser() {
  const ua = window.navigator.userAgent;
  const chrome = /Chrome\/([\d.]+)/.exec(ua) || /CriOS\/([\d.]+)/.exec(ua);
  const webview = !chrome && /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/.exec(ua);
  const safari = webview || /Version\/([\d.]+)([^S](Safari)|[^M]*(Mobile)[^S]*(Safari))/.exec(ua);
  const firefox = /Firefox\/([\d.]+)/.exec(ua);
  const ucbrowser = ua.match(/ucbrowser/g);
  const opera = /opera.([\d.]+)/.exec(ua);
  let browserName = 'unknown';
  if (chrome) {
    browserName = 'Chrome';
  }
  if (safari) {
    browserName = 'Safari';
  }
  if (firefox) {
    browserName = 'Firefox';
  }
  if (ucbrowser) {
    browserName = 'UCWEB';
  }
  if (opera) {
    browserName = 'Opera';
  }
  return browserName;
}

export function getBrowserVersion() {
  const ua = navigator.userAgent;
  let M: RegExpExecArray | string[] =
    /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i.exec(ua) || [];
  let tem;
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return tem[1] || 'unknow';
  }
  if (M[1] === 'Chrome') {
    tem = /\bOPR|Edge\/(\d+)/.exec(ua);
    if (tem !== null) {
      return tem[1];
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  // eslint-disable-next-line no-cond-assign
  if ((tem = /version\/(\d+)/i.exec(ua)) !== null) {
    M.splice(1, 1, tem[1]);
  }
  return M[1];
}

// https://caniuse.com/?search=Intl%3ADateTimeFormat%3AresolvedOptions%3A%20timeZone
// global: 94.83%
export function getTimeZone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
export function isInsideLarkBrowser() {
  return /Lark/i.test(navigator.userAgent);
}

export function isInsideMeegoBrowser() {
  return /Meego/i.test(navigator.userAgent);
}
export const isMacOS = (): boolean => navigator.appVersion.includes('Mac');

export const isDev =
  window?.location?.host?.includes('localhost') ||
  window?.location?.host?.includes('dev') ||
  process.env.NODE_ENV !== 'production';

export { isLocalDev } from './isLocalDev';

export const isBoe = window.location.host.includes('boe');
export const isTemporyMycisBoe = window.location.host.includes('meego-us.feishu-boe.cn');
export const isTemporyMycisProd = window.location.host.includes('meego-my.larkoffice.com');
export const isMobileApp = platformType() === Platform.Mobile;
export const isDesktop = platformType() === Platform.Desktop;
export const isMobileDevice = [Platform.iPhone, Platform.Android, Platform.MobileUA].includes(
  platformType(),
);
// export const isExternal = process.env.external || false;
export const isExternal =
  /(project-trial|project).feishu.cn/.test(window.location.hostname) ||
  process.env.external ||
  false;
import { isKA } from './isKA';
export { isKA };

export const isLarksuiteUnify = window.location.hostname === 'project.larksuite.com';
export const isMeegleUnify = window.location.hostname === 'meegle.com';
export const isVa = process.env.region === 'va' || false;
// cloudnative公有云，larkcloudnative私有云
export const isDataCenter = () => {
  return (
    isKA &&
    (window.__MEEGO_CUSTOM_DEPLOY_ENV__ === 'cloudnative' ||
      window.__MEEGO_CUSTOM_DEPLOY_ENV__ === 'larkcloudnative')
  );
};
export const isJp =
  process.env.region === 'va' && window.location.hostname === 'project-jp.larksuite.com';
export const isVaAt = process.env.region === 'va' && window.location.hostname === 'meegle.com';
export const isSg = window.region === 'sg';

export const isInternal = !(isVa || isKA || isExternal);
export const isInTrialFlow = () =>
  getFirstPathInUrl() === 'tenant' || window.location.pathname.includes('/b/trial');

export const isTemplatesCenter = () => window.location.pathname.startsWith('/templates');

export const isInWorkbench = () =>
  window.location.pathname === '/' || window.location.pathname === '/workbench';

export const isHelpcenter = () => getFirstPathInUrl() === 'helpcenter';

export const isOpenApp = () => getFirstPathInUrl() === 'openapp';

export const isEnterpriseManage = () => getFirstPathInUrl() === 'enterprise_manage';

export const isIntegration = () => window.location.pathname.includes('/b/integration');

export const isLoginPage = () =>
  getFirstPathInUrl().startsWith('loginAsset') || getFirstPathInUrl().startsWith('login-asset');

// 可以获取 env-plugin 插件header，用于日志上报区分环境，其他需求最好不要依赖这个变量
export const getEnvHeader = () => {
  /**
   * 判断是否为线上环境。便于在slardar中做数据过滤(slardar的context只能做有的过滤，无法做无的过滤，所以线上环境需要一个字面量标识不能为""或者其他空)
   * 判断依据：通过header中x-tt-env内容判断。可信预览环境暂时定义为：ppe开头或者boe开头(流水线有规则卡点)，其余则一律视作线上
   */
  const env = window.envHeader || window.__ENV_PLUGIN__?.currentEnv?.envName;
  if (env?.startsWith('ppe') || env?.startsWith('boe')) {
    return env;
  }
  return 'online';
};

export const getLoadSoure = () => window.testSourceHeader || 'default';

// slardar 初始化 context 信息
export const getSlardarInitContexts = () => {
  return {
    page_load_source: window.testSourceHeader || 'default',
    header: getEnvHeader(),
    compile_tool: process.env.COMPILE_TOOL,
    tenant_key: window.userInfo?.tenant_key,
    saas_tenant_key: window.userInfo?.saas_tenant_key,
    bucket_name: window.oss_meta?.bucket_list?.[0]?.bucket_name,

    view_width: window.innerWidth,
    view_height: window.innerHeight,
    // 当前资产 key
    assets_key: window.userLoginInfo?.meego_tenant?.using_meego_asset?.meego_asset_key || '',
    // cdn 选路结果
    cdn_domain: window.scheduledCdnDomain || '',
    // 部署区域标识，pageserver SERVER_REGION环境变量 tce 集群配置 inner ｜ outer ｜ va | jp | sg
    unit_target: window.region || '',
    // 用户实际所在地 cn | us | sg | jp
    user_region: process.env.region || '',
    // 内存限制
    memory_limit_size: performance?.memory?.jsHeapSizeLimit ?? -1,
  };
};

export const isInEnterprise = () => getFirstPathInUrl() === 'enterprise_manage';

import { isLarkGroupTabEnv } from './isLarkGroupTabEnv';
export { isLarkGroupTabEnv };
// export const isLarkGroupTabEnv = true;

/** 这个方法只是判断飞书内的侧边栏，不是飞书内。后续不要再新使用了。另外判断飞书内的逻辑建议把特化逻辑收敛在 ./adaptInFeishu.ts 中 */
export const isFeishuAppSidebar = () => window.navigator.userAgent.includes('sidebar-semi');

export function getScenario() {
  const ua = window.navigator.userAgent;
  if (isLarkGroupTabEnv) {
    return 'group_tab';
  }
  if (ua.includes('nav')) {
    return 'navigation_bar';
  }
  if (ua.includes('workplace')) {
    return 'workbench';
  }
  if (/Lark/i.test(ua)) {
    return 'lark';
  }
  return 'meego_web';
}

export const isLarkIm = window?.navigator?.userAgent.includes('Lark');

export const release_version = process.env.BUILD_VERSION || 'unknow';
export const git_branch = process.env.BUILD_REPO_BRANCH || 'unknow';
export const commonSourceParam = `web/${process.env.build}`;

/**
 * 自动化获取内存泄漏场景
 */
export const isMemoryUsageCheck = process.env.CUSTOM_PIPELINE_MEMORY_USAGE === 'true';
